import { FC } from 'react';

// import { useUpdateRecords } from '@/entities/conversations';

type Props = {
  open: boolean;
  onClose: () => void;
  selectedRowIds: number[];
};

// type EditFormData = {
//   operatorName: string;
//   phoneNumber: string;
//   date: string;
//   callTime: string;
// };

export const RecordsForm: FC<Props> = () => {
  return null;
  // const { control, reset: resetForm, watch } = useForm<EditFormData>();
  // const { isPending: isUpdating, mutateAsync: updateRecords } = useUpdateRecords();
  //
  // const formData = watch();
  //
  // const onSaveChanges = async (data: EditFormData) => {
  //   try {
  //     // Фильтруем пустые значения
  //     const updateData = Object.entries(data).reduce(
  //       (acc, [key, value]) => {
  //         if (value && value.trim() !== '') {
  //           acc[key as keyof EditFormData] = value;
  //         }
  //         return acc;
  //       },
  //       {} as Partial<EditFormData>,
  //     );
  //
  //     await updateRecords({
  //       ids: selectedRowIds,
  //       data: updateData,
  //     });
  //
  //     // Закрываем drawer и сбрасываем форму
  //     onClose();
  //     resetForm();
  //   } catch (error) {
  //     console.error('Ошибка при обновлении записей:', error);
  //   }
  // };
  //
  // return (
  //   <DrawerContent className={'m-4 ml-0 rounded-2xl'}>
  //     <DrawerHeader>
  //       <DrawerTitle className={'font-medium text-lg'}>{'Редактирование нескольких записей'}</DrawerTitle>
  //     </DrawerHeader>
  //     <DrawerBody>
  //       <form className="space-y-6">
  //         <div className="space-y-4">
  //           <Input control={control} name="operatorName" label="ФИО оператора" placeholder="Введите ФИО оператора" />
  //           <Input control={control} name="phoneNumber" label="Номер телефона" placeholder="Введите номер телефона" />
  //           <DateInput control={control} name="date" placeholder="Выберите дату" />
  //           <Input control={control} name="callTime" type="time" label="Время звонка" placeholder="Выберите время" />
  //         </div>
  //       </form>
  //     </DrawerBody>
  //     <DrawerFooter>
  //       <Button
  //         onClick={() => {
  //           onSaveChanges(formData);
  //         }}
  //         disabled={isUpdating}
  //         className="w-full"
  //       >
  //         {isUpdating ? 'Сохранение...' : 'Сохранить'}
  //       </Button>
  //     </DrawerFooter>
  //   </DrawerContent>
  // );
};
